import { Component, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';

import { ConciergeQueriesService } from 'src/shared/services/concierge-queries.service';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { Util } from 'src/shared/util/util';
import { WindowService } from 'src/shared/providers/window.service';

@Component({
    templateUrl: 'damage-claim.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class DamageClaimPage implements OnInit {

  attachment: any;
  errorMessage: string;
  form: UntypedFormGroup;
  submitted: boolean;
  isRightSideContent = true;
  dialogParams: any;

  boundSubmit = this.submit.bind(this);

  private readonly conciergeQueries = inject(ConciergeQueriesService);
  private readonly fb = inject(UntypedFormBuilder);
  private readonly navCtrl = inject(CustomNavController);
  private readonly storage = inject(TidyStorage);
  private readonly rightSidePanelService = inject(RightSidePanelService);
  private readonly util = inject(Util);
  private readonly windowService = inject(WindowService);

  constructor() {
    this.form = this.fb.group({
      detail: ['', Validators.required],
      how: ['', Validators.required],
      link: ['', Validators.required],
      seeking: ['', Validators.required],
    });
  }

  async ngOnInit() {
    this.isRightSideContent = await this.storage.retrieve('dialog-right-side-open') || false;
    this.rightSidePanelService.setDialogPageTitle('Damage Claim');
    if (this.isRightSideContent) {
      this.dialogParams = await this.storage.retrieve('dialog-params');
    }
  }

  async getParam(paramName): Promise<any> {
    let param = this.dialogParams?.[paramName];
    if (param === null || param === undefined) {
      param = this.navCtrl.getParam(paramName)
    }
    if (param === null || param === undefined) {
      param = await this.storage.retrieve(paramName);
    }
    this.storage.save(paramName, param);
    return param;
  }

  addAttachment() {
    //TODO this.attachment =
  }

  async submit() {
    this.errorMessage = '';
    this.submitted = true;
    if (!this.form.valid) {
      return;
    }
    const item = {
      data: {
        subject: 'Damage Claim',
        body: `What did your Pro damage?\n${this.form.value.detail}\n\nHow did your Pro damage it?\n${this.form.value.how}\n\nLink to replacement item or estimate:\n${this.form.value.link}\n\nHow much are you seeking from the pro?\n${this.form.value.seeking}`,
        attachments: [],
        emails: [],
      },
      type: 'support.job_issue',
    };
    try {
      const response = await this.conciergeQueries.createItemMutation.mutateAsync(item);
      this.openChatWithNewSession(response.id);
    } catch (err) {
      this.errorMessage = err.error ? err.error.message : err.message;
    }
  }

  private openChatWithNewSession(sessionId: number): void {
    this.util.showSuccess('Damage Claim Submitted');
    // Store the new session ID so the chat opens to it
    localStorage.setItem('selectedChatSessionId', sessionId.toString());
    localStorage.setItem('autoOpenExpandableChat', 'true');

    if (this.windowService.isDesktopRes) {
      // Desktop: close side panel, chat will auto-open on current page
      this.rightSidePanelService.closeRightSidePanel();
    } else {
      // Mobile: navigate to dashboard where chat will auto-open
      this.navCtrl.navigateForward('properties');
    }
  }

}
